import component from './inview';

export default component;
